import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMedia from 'use-media';
import { createStructuredSelector } from 'reselect';
import { HandleUserSelection, RootState } from 'containers/HandlesPanel/types';
import { makeSelectIsVisibleColorsPanel } from 'containers/Configurator/selectors/general';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import DoorHandlesSubPanel from 'containers/HandlesPanel/DoorHandlesSubPanel';
import { ShelfComposition } from 'lib/modelBuilder/constants';
import DrawersHandleSubPanel from 'containers/HandlesPanel/DrawersHandleSubPanel';
import PanelSelection from '../../../components/PanelSelection';
import { ActivePanel } from '../../Configurator/constants/general';

// import styled from 'styled-components/macro';

interface Props {
  handlePositionSelected: HandleUserSelection[];
  compositions: Set<ShelfComposition>;
  remove: any;
}
interface StateProps {
  isVisible: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  isVisible: makeSelectIsVisibleColorsPanel(ActivePanel.handles),
});

const MobileHandlesPanel = ({
  handlePositionSelected,
  compositions,
  remove,
}: Props) => {
  const dispatch = useDispatch();
  const { isVisible } = useSelector(stateSelector);

  const isMobile = useMedia({ maxWidth: 1023 });
  const hidePanel = () => {
    dispatch(setColorsPanelAction());
  };

  if (!isMobile) return null;

  return (
    <PanelSelection remove={remove} close={hidePanel} isVisible={isVisible}>
      <DoorHandlesSubPanel
        handlePositionSelected={handlePositionSelected}
        bigShelves={
          compositions.size === 1 &&
          (compositions.has(ShelfComposition.LargeTwoDoors) ||
            compositions.has(ShelfComposition.LargeFourDoors))
        }
      />
      <DrawersHandleSubPanel handlePositionSelected={handlePositionSelected} />
    </PanelSelection>
  );
};

export default MobileHandlesPanel;
